import React, { ForwardedRef, forwardRef, useCallback, useState } from "react"
import { SnackbarContent, SnackbarKey, useSnackbar } from "notistack"
import Collapse from "@mui/material/Collapse"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

interface ValidationErrorsSnackbarProps {
  id: SnackbarKey
  errors: string[]
  title: string
}

const ValidationErrorsSnackbar = forwardRef(
  ({ id, errors, title }: ValidationErrorsSnackbarProps, ref: ForwardedRef<null>) => {
    const { closeSnackbar } = useSnackbar()
    const [expanded, setExpanded] = useState(true)

    const handleExpandClick = useCallback(() => {
      setExpanded((oldExpanded) => !oldExpanded)
    }, [])

    const handleDismiss = useCallback(() => {
      closeSnackbar(id)
    }, [id, closeSnackbar])

    return (
      <SnackbarContent ref={ref}>
        <Card
          sx={{
            backgroundColor: "rgb(214, 0, 42)",
            color: "white",
            p: 0,
            filter: "drop-shadow(0 0 1.06rem #aaa)",
          }}
        >
          <CardActions
            sx={{
              padding: "8px 8px 8px 16px",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
              }}
            >
              {title}
            </Typography>
            <div>
              <IconButton
                aria-label="Show more"
                sx={{
                  padding: "8px 8px",
                  transform: "rotate(0deg)",
                  transition: "all .2s",
                }}
                style={expanded ? { transform: "rotate(180deg)" } : undefined}
                onClick={handleExpandClick}
              >
                <ExpandMoreIcon />
              </IconButton>
              <IconButton
                sx={{
                  padding: "8px 8px",
                  transform: "rotate(0deg)",
                  transition: "all .2s",
                }}
                onClick={handleDismiss}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Paper>
              {errors.map((error, i) => (
                <Card key={i}>
                  <Typography sx={{ p: 5, whiteSpace: "pre-wrap" }} key={error}>
                    {error}
                  </Typography>
                </Card>
              ))}
            </Paper>
          </Collapse>
        </Card>
      </SnackbarContent>
    )
  },
)
ValidationErrorsSnackbar.displayName = "ValidationErrorsSnackbar"

export default ValidationErrorsSnackbar
